import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { ITripsOverviewColumn } from '../interfaces';
import TooltipComponent from '../../TooltipComponent';
import { getIsColumnLast } from '../TableHeader/TableHeader';
import { columnsAtom } from '../TripsOverviewState';

interface IThMileageEndProps {
  id: string;
}

function ThMileageEnd(props: IThMileageEndProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const columnsTable = useRecoilValue<ITripsOverviewColumn[]>(columnsAtom);

  return (
    <div
      className="th-sticky b-table-actions"
      style={{ minWidth: '100px', flex: 1, whiteSpace: 'nowrap' }}
    >
      <TooltipComponent
        id={`ridebook-${props.id}`}
        overlay={
          <div style={{ color: '#fff', whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>
            {`${f({
              id: 'enum.corrections.type.tacho',
            })}: `}
            <strong>
              {`${f({
                id: 'tables.tripsOverview.header.tooltip.mileage',
              })}`}
            </strong>
          </div>
        }
        width="300px"
        style={{ top: '35px' }}
        positionLeft={getIsColumnLast(columnsTable, props.id)}
      >
        <div className="d-flex w-100">
          <div id={props.id} className="text-truncate">
            {f({ id: 'enum.corrections.type.tacho' })}
          </div>
        </div>
      </TooltipComponent>
    </div>
  );
}

export default ThMileageEnd;
